import styled, { css } from 'styled-components';
import {
  getTransition,
  mq,
  getSpace,
  getGridSpans,
  maxContentWidth
} from '../../../stylesheets/tools';

const StyledTiltedTeaser = styled.div`
  display: block;
  position: relative;
  width: 100%;
  margin: 0 auto;
  transform-origin: center center;
  background: ${props => props.theme.globalTheme.primary};

  ${mq('m')} {
    min-height: ${getSpace('350px')};

    ${props =>
      !props.hasTeaser &&
      css`
        min-height: ${getSpace('300px')};
      `}
  }

  &:before,
  &:after {
    display: block;
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    background: ${props => props.theme.globalTheme.primary};
  }

  &:before {
    left: calc(-100% + 2px);
  }

  &:after {
    right: calc(-100% + 2px);
  }

  .eventDate__shape svg path {
    fill: ${props => props.theme.globalTheme.primary};
  }

  .tiltedTeaser__wrapper {
    padding: ${getSpace('xxl')} ${getSpace('m')};
    ${maxContentWidth()}
    position: relative;
  }

  .tiltedTeaser__arrow {
    margin-top: ${getSpace('xs')};

    ${mq('m')} {
      opacity: 0;
      visibility: hidden;
    }

    svg {
      width: 60px;
      height: 20px;
    }
  }

  .tiltedTeaser__link {
    align-self: flex-end;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    ${getGridSpans('width', { s: 12, m: 6, l: 5 })}

    ${mq('m')} {
      flex-direction: row;
    }

    &:hover .tiltedTeaser__arrow,
    &:focus .tiltedTeaser__arrow {
      opacity: 1;
      visibility: visible;
    }
  }

  .tiltedTeaser__headline {
    margin-top: ${getSpace('xs')};
  }

  .tiltedTeaser__time {
    margin-top: ${getSpace('xxs')};
    display: block;
  }

  .tiltedTeaser__banner-arrow {
    margin-right: 10px;
    ${getTransition('default', { property: 'transform' })}
  }

  .tiltedTeaser__banner-link {
    text-transform: uppercase;
    position: relative;
    display: flex;
    align-items: center;
    padding: ${getSpace('xs')};
    background: rgba(0, 0, 0, 0.2);

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }

    &:before,
    &:after {
      display: block;
      z-index: 1;
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
      top: 0;
      background: rgba(0, 0, 0, 0.2);
    }

    &:before {
      left: -100%;
    }

    &:after {
      right: calc(-100% + 2px);
    }

    &:hover {
      .tiltedTeaser__banner-arrow {
        transform: translateX(-5px);
      }
    }
  }

  ${props =>
    !props.time &&
    props.teaserPosition === 1 &&
    css`
      background: ${props.theme.globalTheme.secondary};

      &:before,
      &:after {
        background: ${props.theme.globalTheme.secondary};
      }

      .eventDate__shape svg path {
        fill: ${props.theme.globalTheme.secondary};
      }
    `}

  ${props =>
    !props.time &&
    props.teaserPosition === 2 &&
    css`
      background: ${props.theme.globalTheme.tertiary};

      &:before,
      &:after {
        background: ${props.theme.globalTheme.tertiary};
      }

      .eventDate__shape svg path {
        fill: ${props.theme.globalTheme.tertiary};
      }
    `}
  ${props =>
    props.event &&
    css`
      .tiltedTeaser__link {
        ${getGridSpans('width', { s: 12, m: 8 })}
        ${props.teaserPosition === 2 ? getGridSpans('margin-left', { s: 0, m: [4, 'spread'] }) : ''}
      }

      .tiltedTeaser__event {
        margin-bottom: ${getSpace('xs')};

        ${mq('m')} {
          align-self: center;
          left: 25px;
          margin-top: 10px;

          ${mq('m')} {
            margin-top: 0;
          }
        }

        .eventDate__arrow-wrapper {
          transform: rotate(90deg);
          bottom: -5px;
          right: 0;

          ${mq('m')} {
            transform: none;
            right: -15px;
            bottom: 25px;
          }
        }
      }

      .tiltedTeaser__content {
        ${getGridSpans('width', { s: 12, m: [5, 'spread', 8] })}

        ${mq('m')} {
          ${'' /* border: 2px solid black;
          border-radius: 8px; */}
          padding: 50px;
        }
      }

      .tiltedTeaser__categories {
        ${mq('m')} {
          justify-content: flex-end;
        }
      }
    `}

  ${props =>
    props.teaserPosition > 1 &&
    css`
      margin-top: -30px;

      ${mq('m')} {
        margin-top: -100px;
      }

      .tiltedTeaser__content-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
      }

      .tiltedTeaser__link {
        justify-content: flex-end;
      }
    `}

    ${props =>
      props.currentTheme === 'primary' &&
      css`
        background: ${props.theme.globalTheme.primary};

        &:before,
        &:after {
          background: ${props.theme.globalTheme.primary};
        }

        .eventDate__shape svg path {
          fill: ${props.theme.globalTheme.primary};
        }
      `}

    ${props =>
      props.currentTheme === 'secondary' &&
      css`
        background: ${props.theme.globalTheme.secondary};

        &:before,
        &:after {
          background: ${props.theme.globalTheme.secondary};
        }

        .eventDate__shape svg path {
          fill: ${props.theme.globalTheme.secondary};
        }
      `}

    ${props =>
      props.currentTheme === 'tertiary' &&
      css`
        background: ${props.theme.globalTheme.tertiary};

        &:before,
        &:after {
          background: ${props.theme.globalTheme.tertiary};
        }

        .eventDate__shape svg path {
          fill: ${props.theme.globalTheme.tertiary};
        }
      `}

    ${({ banner }) =>
      banner?.position === 'right' &&
      css`
        .tiltedTeaser__banner-arrow {
          margin-left: 10px;
          margin-right: 0;
          transform: rotate(180deg);
        }

        .tiltedTeaser__banner-link {
          align-items: flex-end;
          flex-direction: row-reverse;

          &:hover {
            .tiltedTeaser__banner-arrow {
              transform: rotate(180deg) translateX(-5px);
            }
          }
        }
      `}
`;

export default StyledTiltedTeaser;
